import script from "./AppointmentcompleteView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentcompleteView.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentcompleteView.vue?vue&type=style&index=0&id=a5c2e5a0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c2e5a0"]])

export default __exports__